






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class EnSalary extends Vue {
    @Prop({ type: [Object, Array] })
    data!: Voucher.Voucher[];
    salaryList: Voucher.Voucher[] = this.data;

    mounted() {
    }

    @Watch("data")
    dataChange(val: Voucher.Voucher[]) {
        this.salaryList = val;
    }
}
